function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Children, cloneElement, isValidElement } from 'react'; // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types

export function drillProps(children, props, indexPropName) {
  return Children.map(children, (child, index) => {
    var indexProp = indexPropName ? {
      ["".concat(indexPropName)]: index
    } : undefined; // eslint-disable-next-line @typescript-eslint/no-unsafe-argument

    if ( /*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement(child, _objectSpread(_objectSpread({}, props), indexProp));
    }

    return child;
  });
}
//# sourceMappingURL=render-utils.js.map